export default {"src":"/_next/static/media/oil.fdda3f8c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};